/* Yellow Creek editorial mega menu: category hover/focus swaps imagery for links. */
(function () {
  if (window.__ycEditorialMegaInitialized) return;
  window.__ycEditorialMegaInitialized = true;

  function show(menu, id) {
    var panels = menu.querySelectorAll('[data-yc-flyout-panel]');
    var triggers = menu.querySelectorAll('[data-yc-flyout]');
    var found = false;
    panels.forEach(function(panel) {
      var active = id && panel.getAttribute('data-yc-flyout-panel') === id;
      panel.hidden = !active;
      if (active) found = true;
    });
    triggers.forEach(function(trigger) {
      trigger.classList.toggle('is-yc-active', !!id && found && trigger.getAttribute('data-yc-flyout') === id);
    });
    menu.classList.toggle('is-yc-flyout-active', found);
  }

  document.addEventListener('pointerover', function(event) {
    if (!window.matchMedia('(min-width:769px)').matches) return;
    var menu = event.target.closest('.yc-editorial-menu');
    if (!menu) return;
    var link = event.target.closest('.yc-editorial-menu__links a');
    if (!link) return;
    show(menu, link.getAttribute('data-yc-flyout'));
  });
  document.addEventListener('focusin', function(event) {
    var menu = event.target.closest('.yc-editorial-menu');
    if (!menu) return;
    var link = event.target.closest('.yc-editorial-menu__links a');
    if (link) show(menu, link.getAttribute('data-yc-flyout'));
  });
  document.addEventListener('pointerout', function(event) {
    var menu = event.target.closest('.yc-editorial-menu');
    if (!menu) return;
    if (event.relatedTarget && menu.contains(event.relatedTarget)) return;
    show(menu, null);
  });
  document.addEventListener('focusout', function(event) {
    var menu = event.target.closest('.yc-editorial-menu');
    if (!menu) return;
    if (event.relatedTarget && menu.contains(event.relatedTarget)) return;
    show(menu, null);
  });
})();
